define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PresignedUrlRequestAssetModel = (function () {
        function PresignedUrlRequestAssetModel() {
            this.fileName = null;
            this.size = 0;
            this.Asset = null;
        }
        return PresignedUrlRequestAssetModel;
    }());
    exports.PresignedUrlRequestAssetModel = PresignedUrlRequestAssetModel;
});
//# sourceMappingURL=PresignedUrlRequestAssetModel.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/PresignedUrlRequestAssetModel.js
// module id = 376
// module chunks = 0